import fetchTopicTree from './action-topic-list';
import { fetchArticle } from '../../contactUs/actions/action-article';
import { resetRelatedArticle } from '../../contactUs/actions/action-related-article';
import { updateBreadCrumbFromArticleContent } from './action-breadcrumb';
import getCommunityResults from './action-community-posts';
import getOpenCase from '../actions/action-case-checker';
import * as Page from '../../lib/page';

export default function fetchArticleContent(experience, faqid) {
  return (dispatch, getState) => {
    dispatch(resetRelatedArticle());
    const { topicList } = getState();
    if (topicList && topicList.topics && topicList.topics.length <= 0) {
      dispatch(fetchTopicTree(experience));
    }
    dispatch(fetchArticle(faqid, true))
      .then((response) => {
        if (response && response.payload) {
          dispatch(updateBreadCrumbFromArticleContent(response.payload));
          dispatch(getCommunityResults({ title: response.payload.articleTitle, id: faqid }));
          if (Page.isLoggedIn() && Page.isDisputeArticle(response.payload.articleTitle)) {
            dispatch(getOpenCase());
          }
        }
      });
  };
}
